import { NavBar } from "../components/NavBar";
import { Footer } from "../components/Footer";

export function FaqPage() {
  const faqs = [
    { 
      q: "¿Qué es Servix?", 
      a: "Es una plataforma digital operada por NUOVOCELL que conecta a clientes con proveedores de servicios de lubricación y mantenimiento vehicular a domicilio." 
    },
    { 
      q: "¿Quién puede registrarse?", 
      a: "Cualquier persona mayor de 18 años. Se requiere proporcionar información veraz sobre el vehículo y la ubicación para coordinar el servicio." 
    },
    { 
      q: "¿Cómo se realizan los pagos?", 
      a: "El pago se gestiona directamente entre el cliente y el proveedor (efectivo o transferencia). Debes adjuntar el comprobante a través de nuestra aplicación." 
    },
    { 
      q: "¿Servix es responsable de la calidad del servicio?", 
      a: "Servix actúa únicamente como intermediario tecnológico. La calidad y seguridad del mantenimiento es responsabilidad directa del proveedor asignado." 
    },
    { 
      q: "¿Están seguros mis datos personales?", 
      a: "Sí, utilizamos servidores seguros de Amazon Web Services (AWS) con cifrado SSL/TLS tanto en tránsito como en reposo para proteger su información." 
    },
    { 
      q: "¿Cómo puedo eliminar mi cuenta?", 
      a: "Puede solicitar la eliminación de su cuenta y todos sus datos asociados escribiendo un correo electrónico a admin@servix.com.ve." 
    },
  ];

  return (
    <div className="min-h-screen bg-[#f6f8fb] text-slate-800 flex flex-col">
      <NavBar isLogged={false} />

      <header className="bg-gradient-to-r from-primary to-primary-hover text-white">
        <div className="mx-auto max-w-5xl px-6 py-10">
          <p className="text-xs uppercase tracking-[0.12em] text-white/80">Ayuda</p>
          <h1 className="text-3xl font-bold">Preguntas frecuentes</h1>
          <p className="mt-2 text-sm md:text-base text-white/90">
            Encuentre respuestas rápidas sobre cómo funciona Servix, nuestra seguridad y términos legales.
          </p>
        </div>
      </header>

      <main className="flex-1">
        <section className="mx-auto max-w-5xl px-6 py-12">
          <div className="grid gap-6 md:grid-cols-2">
            {faqs.map((item, index) => (
              <div key={index} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm hover:shadow-md transition-shadow">
                <h2 className="text-lg font-semibold text-slate-900">{item.q}</h2>
                <p className="mt-3 text-sm leading-relaxed text-slate-700">{item.a}</p>
              </div>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}